module.exports = __webpack_public_path__ + "static/img/customers.3020767.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/customers.png
// module id = AKrW
// module chunks = 2